<template>
    <div>
        <div class="second-header-wrap">
            <el-button size="medium" @click="saveHandler" type="primary">保存</el-button>
        </div>
        <div>
            <div class="item">
                <el-checkbox v-model="realLive" :true-label="1" :false-label="0">实际居住(老师家访时标记实际居住)</el-checkbox>
            </div>
            <div class="item">
                <el-checkbox v-model="notSingleParent" :true-label="1" :false-label="0">非单亲家庭</el-checkbox>
            </div>
            <div class="item">
                <el-checkbox v-model="dataComplete" :true-label="1" :false-label="0">所有必填字段和材料完整</el-checkbox>
            </div>
            <div class="item">
                <el-checkbox v-model="teachingArea" :true-label="1" :false-label="0">房产证在施教区(产权地址的施教区必须是字典选择)</el-checkbox>
            </div>
            <div class="item">
                <el-checkbox v-model="parentProperty" :true-label="1" :false-label="0">房产证是孩子父母</el-checkbox>
            </div>
            <div class="item">
                <el-checkbox v-model="hasPropertyDate" :true-label="1" :false-label="0">房产证最迟办证日期</el-checkbox>&nbsp;&nbsp;
                <span class="extra-input" v-show="hasPropertyDate === 1">
                    日期：
                    <el-date-picker
                        type="date"
                        placeholder="选择日期"
                        v-model="propertyDate"
                        :clearable="false"
                    >
                        </el-date-picker>
                </span>
            </div>
            <div class="item">
                <el-checkbox v-model="hasSettleDate" :true-label="1" :false-label="0">最迟落户时间</el-checkbox>&nbsp;&nbsp;
                <span class="extra-input" v-show="hasSettleDate === 1">
                    日期：
                    <el-date-picker
                        type="date"
                        placeholder="选择日期"
                        v-model="settleDate"
                        :clearable="false"
                    >
                        </el-date-picker>
                </span>
            </div>
            <div class="extra-input">
                分组数：
                <el-input-number v-model="groupNum" size="small" :precision="0" :min="1" :step="1" :max="20"></el-input-number>
            </div>
        </div>
    </div>
</template>

<script>
    import {getSchoolGroupSetInfo, addEnrolGroupSet} from '@/api/primary/setting.js';
    import moment from 'moment';

    export default {
        name: "GroupingSetting",
        data: function () {
            return {
                realLive: 0,
                dataComplete: 0,
                notSingleParent: 0,
                groupNum: 0,
                hasPropertyDate: 0,
                parentProperty: 0,
                propertyDate: moment().format('YYYY-MM-DD'),
                teachingArea: 0,
                hasSettleDate: 0,
                settleDate: moment().format('YYYY-MM-DD')
            }
        },
        methods: {
            saveHandler() {
                addEnrolGroupSet({
                    realLive: this.realLive,
                    dataComplete: this.dataComplete,
                    notSingleParent: this.notSingleParent,
                    groupNum: this.groupNum,
                    hasPropertyDate: this.hasPropertyDate,
                    parentProperty: this.parentProperty,
                    propertyDate: this.hasPropertyDate === 1 ? moment(this.propertyDate).format('YYYY-MM-DD') : '',
                    teachingArea: this.teachingArea,
                    hasSettleDate: this.hasSettleDate,
                    settleDate: this.hasSettleDate === 1 ? moment(this.settleDate).format('YYYY-MM-DD') : '',
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            this.$message({
                                message: '设置成功',
                                type: 'success'
                            });
                        }
                    })
            }
        },
        created() {
            getSchoolGroupSetInfo()
                .then(res => res.data)
                .then(data => {
                    const pageData = data.data;
                    this.notSingleParent = pageData.notSingleParent;
                    this.realLive = pageData.realLive;
                    this.dataComplete = pageData.dataComplete;
                    this.groupNum = pageData.groupNum;
                    this.hasPropertyDate = pageData.hasPropertyDate;
                    this.parentProperty = pageData.parentProperty;
                    this.propertyDate = pageData.propertyDate;
                    this.hasSettleDate = pageData.hasSettleDate;
                    this.settleDate = pageData.settleDate;

                    this.teachingArea = pageData.teachingArea;
                })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
    }

    .item {
        margin: 20px 0;
    }

    .extra-input {
        font-size: 14px;
        color: #606266;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/setting/GroupingSetting.vue